import {Button, Grid, Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import {useDispatch} from "react-redux";
import {simSetSelectedRowSchedaTehnica} from "../../../../../../../store";

const SuccessDialogContent = () => {
    return (
        <Typography variant="body2"
                    color="textSecondary">
            La modifica della tipologia di APN sarà attiva entro pochi minuti e per renderla operativa sarà necessario
            modificare le impostazioni del device inserendo il nuovo APN ed eventualmente Username e Password
        </Typography>
    )
}

const SuccessDialogActions = (props) => {
    const dispatch = useDispatch()

    const handleChiudiClick = () => {
        if (props.loadSchedaTecnica) {
            dispatch(simSetSelectedRowSchedaTehnica(props.iccId))
        }
        props.handleClose()
    }

    return (
        <Grid container
              justifyContent="flex-end">
            <Button variant="contained"
                    color="primary"
                    onClick={handleChiudiClick}>
                Chiudi
            </Button>
        </Grid>
    )
}

SuccessDialogActions.propTypes = {
    handleClose: PropTypes.func.isRequired,
    loadSchedaTecnica: PropTypes.bool.isRequired
}

export {SuccessDialogActions, SuccessDialogContent}
